import L_HTML5 from "./assets/skills/html-5.svg";
import L_CSS3 from "./assets/skills/css3.svg";
import L_BOOTSTRAP from "./assets/skills/bootstrap-4.svg";
import L_REACT from "./assets/skills/react.svg";
import L_REACT_BOOTSTRAP from "./assets/skills/react-bootstrap.svg";
import L_NODE_JS from "./assets/skills/nodejs.svg";
import L_EXPRESS from "./assets/skills/express.svg";
import L_GIT from "./assets/skills/git-icon.svg";
import L_HEROKU from "./assets/skills/heroku.svg";
import L_GITHUB_PAGES from "./assets/skills/github.svg";
import L_JAVASCRIPT from "./assets/skills/javascript.svg";
import L_JAVA from "./assets/skills/java.svg";
import L_PYTHON from "./assets/skills/python.svg";
import L_CPLUSPLUS from "./assets/skills/cplusplus.svg";
import L_MONGODB from "./assets/skills/mongodb.svg";
import L_FIREBASE from "./assets/skills/firebase-icon.svg";
import L_RACKET from "./assets/skills/racket.png";
import L_ANGULAR from "./assets/skills/angularjs.png";
import L_NGRX from "./assets/skills/ngrx.svg";
import L_RXJS from "./assets/skills/rxjs.png";
import L_ASP from "./assets/skills/asp.png";
import L_TYPESCRIPT from "./assets/skills/typescript.svg";
import L_CSHARP from "./assets/skills/csharp.png";
import L_ORACLE from "./assets/skills/oracle.svg";
import L_MYSQL from "./assets/skills/mysql.png";
import L_EXPO from "./assets/skills/expo.png";
import L_REDUX from "./assets/skills/redux.svg";
import L_FLASK from "./assets/skills/flask.svg";
import L_FLUTTER from "./assets/skills/flutter.svg";
import L_COCKROACHDB from "./assets/skills/cockroachdb.svg";
import L_TWILIO from "./assets/skills/twilio.svg";


// import P_ELDERAID from "./assets/images/elderaid.png";
import P_ELDERAID from "./assets/images/EA.svg";

// import P_EAS from "./assets/images/eas.png";
import P_EAS from "./assets/images/E-A-S.svg";

// import P_FOODTRACKER from "./assets/images/food.png";
import P_FOODTRACKER from "./assets/images/FT.svg";

// import P_LIBRARY from "./assets/images/library.png";
import P_LIBRARY from "./assets/images/LM.svg";

// import P_CALC from "./assets/images/calc.png";
import P_CALC from "./assets/images/CL.svg";
// import P_POKEMON from "./assets/images/pokemon.png";
import P_POKEMON from "./assets/images/PB.svg";

// import P_GOOGLE from "./assets/images/google.png";
import P_GOOGLE from "./assets/images/GH.svg";

// import P_FITNESSBLOG from "./assets/images/fitblog.jpg";
import P_FITNESSBLOG from "./assets/images/FB.svg";

// import P_WEATHERAPP from "./assets/images/weatherapp.jpg";
import P_WEATHERAPP from "./assets/images/WA.svg";

// import P_BUSINESS from "./assets/images/bms1.jpg";
import P_BUSINESS from "./assets/images/BM.svg";

// import P_YUGI from "./assets/images/yugi2.jpg";
import P_YUGI from "./assets/images/YD.svg";

// import P_TASK from "./assets/images/task.png";
import P_TASK from "./assets/images/TM.svg";

// import P_JUMPGAME from "./assets/images/Jumpgame.jpg";
import P_JUMPGAME from "./assets/images/JG.svg";

// import P_GYMMANAGER from "./assets/images/gymManager.png";
import P_GYMMANAGER from "./assets/images/GM.svg";

// import P_ANIMEDIA from "./assets/images/animedia.png";
import P_ANIMEDIA from "./assets/images/AM.svg";

// import P_WORDGAME from "./assets/images/wordGame.png";
import P_WORDGAME from "./assets/images/WG.svg";

// import P_CHAT from "./assets/images/sig.png";
import P_CHAT from "./assets/images/CA.svg";

import P_VIBESPHERE from "./assets/images/vib.png";

import P_TEXTMEMOIRS from "./assets/images/textmem.png";

import P_PDFTONOTION from "./assets/images/pdfnotion.png";

export const topProjects = [
  {
    title: "ElderAid",
    subtitle: "MERN Stack",
    description:
      "A web app to help seniors get the support they need during the pandemic in completing essential everyday tasks (grocery shopping, picking up medicine, etc) that could potentially expose them to the virus",
    data: {
      description:
        "ElderAid is a web application that aims to provide a platform for elderly individuals to connect with young volunteers who can assist with tasks such as grocery shopping, providing companionship, and other forms of support. Built using React.js for the frontend, Express.js for the backend, and a MongoDB database, ElderAid simplifies the process of finding and connecting with reliable volunteers in the community. Through a verification process for youth volunteers and an in-app chat interface, ElderAid allows elderly individuals to receive assistance in a safe and convenient manner. With the added risk of exposure to COVID-19, ElderAid provides a valuable solution for elderly individuals who may not be able to leave their homes or are immunocompromised. ElderAid is designed to be easy to use, ensuring that even those who may not be tech-savvy can benefit from its services.",
      tech: {
        React: L_REACT,
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        MongoDB: L_MONGODB,
      },
      features: [
        "Seniors and Volunteers Registration and Login",
        "Admin Verification of Volunteers' COVID19 Test Results",
        "Senior and Volunteer Matching System based on Location Proximity",
        "Profile Customization",
        "Senior to Volunteer Partner Invites",
        "Volunteer to Senior Invitation Acceptance/Rejection",
      ],
    },
    image: P_ELDERAID,
    link: "https://devpost.com/software/elderaid",
  },
  {
    title: "Gym Manager",
    subtitle: "MySQL, Express, Node, React",
    description:
      "The Gym Manager is a comprehensive gym management application designed to streamline operations for gym owners, staff, trainers, managers, and customers",
    data: {
      description:
        "The Gym Manager is a comprehensive gym management application designed to streamline operations for gym owners, staff, trainers, managers, and customers. With this tool, gym owners can easily add locations and machines, update location revenues, view employee information, and make personnel changes. Customers can select their preferred gym location, upgrade their membership plans, access trainers, and view available fitness class times. This project was motivated by the opportunity to design and implement a robust database system. The development process included ideation, Entity-Relationship diagram creation, relational model development, table creation, functional dependency identification, normalization to 3NF or BCNF, and SQL file creation. Overall, the Gym Manager serves as a powerful tool for optimizing gym management and providing a seamless experience for all users.",
      tech: {
        React: L_REACT,
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        MySQL: L_MYSQL,
      },
      features: [
        "Gym Owner, Staff, Trainer, Manager and Customer Registration and Login",
        "Profile Customization",
        "Allows Gym Owners to Manage their Gym Locations",
        "Gym Owners Can Add New Locations, Update Location Revenues, View Employees Working at Those Locations and Fire Employees if They are Spending Too Much on Salaries",
        "Owners Can View the Equipment They Have at Each Location and Add More if They Want To",
        "Customers Can Select Their Preferred Gym Location, Upgrade Their Membership Plan, View All the Trainers They Have Access To and Find Available Fitness Class Times",
        "Users Can Find the Number of Machines That Are in Their Gym Based On The Exercise Category (Strength, Cardio, Endurance, Hypertrophy, etc.)",
        "Customers Can Check Which Gyms are Fully Equipped (Have Machines of Every Possible Type/Model)",
      ],
    },
    image: P_GYMMANAGER,
    link: "https://github.com/Parmvir-S/Gym-Manager",
  },
  {
    title: "AniMedia",
    subtitle: "MERN Stack",
    description:
      "AniMedia is a web application that allows users to search for, rate, review and favourite anime that they have watched",
    data: {
      description:
        "The main motivation for this anime reviewing application was to provide my siblings and cousins a place to review the anime they have watched and keep track of them through their favourites page. By having a rating and reviewing system, all of the kids in my family are able to better gauge what they want to watch next. Also in the future all of us can look back at the reviews we left and the anime we have watched.",
      tech: {
        React: L_REACT,
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        MongoDB: L_MONGODB,
      },
      features: [
        "User Registration and Login",
        "Profile Customization",
        "Users Can Search Any Anime They Want and Add It To Their Favourites",
        "Users Can View The Animes They Have Favourited On The Favourites Page",
        "Users Can Rate An Anime on a Scale of 1-10",
        "Users Can Leave Reviews on Anime and View the Reviews Left By Others",
        "More Information About the Main Characters of an Anime Can Be Viewed By Clicking On The Characters Picture In The Marquee",
        "Users Can View All the Top Rated Anime On The Main Page",
      ],
    },
    image: P_ANIMEDIA,
    link: "https://github.com/Parmvir-S/AnimeReviewer-Frontend",
  },
  {
    title: "Word Game",
    subtitle: "Express, Node, React and Firebase",
    description:
      "An online game that allows users to connect to the same room and play an interactive game together, where players come up with words related to topics that start with a specified letter before the time runs out",
    data: {
      description:
        "Word Game is a web-based multiplayer game that utilizes websockets to allow users to connect to the same room and play an interactive word game together. The game features a room creation system, where one player can create a room and share the room name with other players. The game also includes a game master system, where one player can start the game by selecting a random letter and starting the timer. Players must come up with words related to the given topics and starting with the specified letter. At the end of the game, players' scores are calculated based on the uniqueness of their chosen words. Word Game was developed using Node.js and Socket.io to enable real-time communication between players. The motivation behind this project was to create an online version of the popular family game Scattegories, using modern web technologies to improve the gameplay experience and reduce paper usage.",
      tech: {
        React: L_REACT,
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        Firebase: L_FIREBASE,
      },
      features: [
        "One Player Can Create a Room and Share That Rooms Name With as Many People as He/She Wants",
        "Players Can Enter a Room Using a Room Name and Join the Game.",
        "Users Can Create New Topics, Get Topics From a Database of Previously Made Topics or Choose Random Topics To Play With",
        "The Designated Game Master Can Start the Game by Randomly Selecting a Letter and Starting the Timer",
        "Players in the Room Will Type Out words that Are Related to the Topics Being Displayed on the Page and Start With the Specified Letter",
        "Once the Time Is Up, Users Can Compare Answers to Get Points. Players Can Keep Track of Their Scores Using the Score Incrementer",
      ],
    },
    image: P_WORDGAME,
    link: "https://github.com/Parmvir-S/wordgame",
  },
  {
    title: "Business Management System",
    subtitle: "Java",
    description:
      "The Business Management System is a Java application that allows a business to manage its items/services, track customer purchases, and view sales statistics. It simplifies business management and makes it more efficient and cost-effective",
    data: {
      description:
        "The Business Management System is a Java desktop application designed to streamline and improve the efficiency of small businesses. It allows users to create, view, update, and delete items and services offered by the business, as well as track customer purchases and generate receipts. The application also provides data on the business's total revenue, popular items and services, and number of customers served. It is intended for use by small business owners and their employees to manage and track customer purchases in a cost-effective way, eliminating the need for manual record keeping or outsourcing to third parties. This project was inspired by the desire to help small businesses, including my younger sister who recently opened her own business, streamline her operations and increase profits.",
      tech: {
        Java: L_JAVA,
      },
      features: [
        "Users can add an item/service to the catalogue list",
        "Users can view all the items/services in the catalogue list",
        "Users can select ('add to customer cart') specific items/services in the catalogue list",
        "Users can remove ('remove from customer cart') specific items/services",
        "Users can update existing items/services in the catalogue list",
        "Users can delete items/services in the catalogue list",
        "Owners are able to print a receipt of the customers purchases",
        "Owners able to view what the total sales to date are and view how many customers have been serviced to date",
        "Users, when at the main application menu, are reminded to save the store and customer data to file and have the option to do so or not",
        "When the application starts, Users are given the option to load store and customer data",
      ],
    },
    image: P_BUSINESS,
    link: "https://github.com/Parmvir-S/The-Business-Management-System",
  },
  {
    title: "Text Memoirs",
    subtitle: "Express, Node, Flutter, CockroachDB, Twilio",
    description:
      "Your accessible journaling solution. Capture the power of journaling for mental well-being. Reflect, reduce stress, and track growth effortlessly through real-time text entries. Boost self-awareness, understand triggers, and enjoy universal benefits with ease.",
    data: {
      description:
        "Journalling is a well-established practice that has been shown to have many benefits for mental health and overall well-being. Some of the main benefits of journalling include the ability to reflect on one's thoughts and emotions, reduce stress and anxiety, and document progress and growth. By writing down our experiences and feelings, we are able to process and understand them better, which can lead to greater self-awareness and insight. We can track our personal development, and identify the patterns and triggers that may be contributing to our stress and anxiety. Journalling is a practice that everyone can benefit from. Text Memoirs is designed to make the benefits of journalling easy and accessible to everyone. By using a mobile text-message based journaling format, users can document their thoughts and feelings in a real-time sequential journal, as they go about their day. Simply text your assigned number, and your journal text entry gets saved to our database. You're journal text entries are then displayed on our web app GUI. You can view all your text journal entries on any given specific day on the GUI.",
      tech: {
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        CockroachDB: L_COCKROACHDB,
        Flutter: L_FLUTTER,
        Twilio: L_TWILIO
      },
      features : [
        "Utilized Twilio's API to seamlessly receive and securely store users' text messages.",
        "Empowered users to share thoughts by sending text messages directly to the assigned Twilio number.",
        "Facilitated direct, immediate recording of thoughts and emotions into the database via text messages.",
        "Enabled users to manage journal entries via text commands like /EDIT and /DELETE.",
        "Effortlessly updated text journal entries in both the database and GUI through user-friendly commands.",
        "Stored messages in a robust CockroachDB database, ensuring confidentiality and data integrity.",
        "Constructed an engaging, visually appealing frontend interface using the versatile Flutter framework.",
        "Deployed the backend server on an AWS EC2 instance, and the database in the cloud."
      ]
    },
    image: P_TEXTMEMOIRS,
    link: "https://devpost.com/software/text-memoirs",
  },
  {
    title: "Vibeshere",
    subtitle: "Express, Node, React, MongoDB, Redux, Flask",
    description:
      "Discover new music with a tailored Spotify recommender app. Store favorite tracks, get precise song suggestions, and enjoy features like playlists and social sharing. Your music journey starts here",
    data: {
      description:
        "Vibesphere is a nifty Spotify song recommender application tailored for music enthusiasts seeking to unearth new tracks that mirror their existing preferences. The app, leveraging the Spotify API, stores user-inputted songs, generates precise song recommendations, and offers a robust platform to like, play, and share these music pieces. With additional features like public playlists, user profiles, and playlist-based recommendations, Vibesphere is a haven for music discovery and social sharing.",
      tech: {
        React: L_REACT,
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        MongoDB: L_MONGODB,
        Redux: L_REDUX,
        Flask: L_FLASK
      },
      features: [
        "Set up a basic input textbox to capture user input so API calls can be made to the Spotify backend using the search query to retrieve song results. Then displayed the list of songs from the Spotify API response",
        "Dynamically fetched matching song results as the user types and allowed users to select songs from the displayed list to get similar song reccomendations",
        "Custom-wrote a machine learning algorithm for song recommendations, training it on a CSV file with approximately 200,000 songs",
        "Provided recommendations by analyzing user-inputted songs against the trained algorithm",
        "Set up React Router to create multiple pages: homepage, about section, and scoreboard",
        "Implemented user authentication, allowing users to create profiles for personalized features",
        "Integrated the Spotify API to provide song previews directly on the app",
        "Enabled users to like or favorite songs, storing preferences for each user",
        "Created a leaderboard showcasing the most liked songs",
        "Tracked and displayed globally searched songs on the homepage in a carousel",
        "Developed a public playlist feature, allowing users to collaboratively create playlists",
        "Implemented song recommendations based on user-inputted songs",
        "Prepopulated search results dynamically with each typed character",
      ]      
    },
    image: P_VIBESPHERE,
    link: "https://vibesphere.onrender.com/",
  },
  {
    title: "PDF To Notion",
    subtitle: "Python",
    description:
      "This time-saving script simplifies lecture preparation by taking a PDF, splitting it up into individual images, and pasting them in a new Notion page with spaces inbetween for note taking purposes.",
    data: {
      description:
        "This project demonstrates the power of automation using Python to streamline repetitive tasks. By leveraging APIs from Notion and Dropbox, the script efficiently converts PDFs to images, uploads them to a cloud storage service, and integrates them seamlessly into Notion for note-taking. The motivation behind this project was to create a time-saving solution for preparing lecture materials, which could also be applied to various scenarios where image integration and organization are needed.",
      tech: {
        Python: L_PYTHON
      },
      features : [
        "Converts each page of a PDF into images.",
        "Uploads the images to Dropbox and generates shareable links for the images.",
        "Creates a new Notion page with the images and spaces in between for note-taking.",
        "Saves time when setting up for lectures."
      ]
    },
    image: P_PDFTONOTION,
    link: "https://github.com/Parmvir-S/PDF-To-Notion",
  },
  // Add the UBC Course Selector/Explorer - CPSC 310 Project
  // Add the Localization Helper VS Code Extension
  // SXHKD Keybindings Viewer
  // Song Streamer Script
  // Multiplayer Connect 4
  // Py-Terminal Emulator
  // Add A kaboom js game
];

export const projects = [
  {
    title: "Etch-A-Sketch",
    subtitle: "HTML CSS Javascript",
    description:
      "Etch-a-Sketch is a simple web application that allows users to create simple drawings by hovering over a dynamically generated grid using their mouse. It features a clean interface and allows users to customize the size of the grid to suit their needs",
    data: {
      description:
        "Etch-a-Sketch is a web application that allows users to create simple drawings by hovering over a dynamically generated grid using their mouse. The app is built using HTML, CSS and vanilla JavaScript, with the main focus being on understanding the document object model (DOM) and learning how to manipulate it. The user can choose the size of the grid they want to draw on, ranging from 1x1 to 50x50. The app also includes a hover effect that changes the color of the grid squares when the mouse passes over them, creating a pixelated trail. A clear drawing button is also included, allowing the user to start a new drawing at any time.",
      tech: {
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Users can resize the grid on which they want to draw on (ex. 4x4, 16x16, 20x20, 50x50, etc.)",
        "Users can draw on the grid by moving their mouse over it",
        "Users can clear the grid by hitting the clear button",
      ],
    },
    image: P_EAS,
    link: "https://parmvir-s.github.io/etch-a-sketch/",
  },
  {
    title: "Chat App",
    subtitle: "React Native, Firebase",
    description:
      "The Chat App is a real-time messaging platform that allows users to connect and communicate with each other in a variety of different chat rooms. The app features user authentication and a clean, intuitive interface that makes it easy for users to navigate and interact with the app",
    data: {
      description:
        "The Chat App is a real-time messaging application built using React Native and Firebase. It allows users to create an account, log in, create a chat room and join a chat room to communicate with other users in real-time. The app utilizes Firebase to enable real-time communication, allowing users to receive and send messages as they are typed. The app also uses Firestore to store user accounts and chat logs. The motivation behind this project was to learn how to build a real-time messaging application and gain a deeper understanding of how React Native works. The Chat App also provided an opportunity to work with a NoSQL database and implement user authentication using Firebase methods.",
      tech: {
        "React Native": L_REACT,
        Expo: L_EXPO,
        Firebase: L_FIREBASE,
      },
      features: [
        "Account registration and login: Users can create an account and log in to the app using their email address and password",
        "Chat rooms: Users can create chat rooms and invite other users to join them",
        "Real-time chat: Users can have real-time conversations with other users who are in the same chat room as them",
        "Profile pictures: Users can update their profile pictures in the app's settings",
        "Profile pages: Users can view their own profile page as well as the profile pages of other users",
      ],
    },
    image: P_CHAT,
    link: "https://github.com/Parmvir-S/chat-app-react-native",
  },
  {
    title: "YugiDex",
    subtitle: "React, React Bootstrap, Firebase",
    description:
      "Created a PokeDex-like application for Yugioh fans using React JS, React Bootstrap, Axios, and Firebase. Users can look up Yugioh cards using their name, type, attribute and level. Once the user has found the card of their choice, they can add that card to their deck which is persisted via the firebase database",
    data: {
      description:
        "YugiDex is a web application that allows users to search for and save information about Yu-Gi-Oh! cards to their personal list. It is built using React, React Bootstrap and Firebase, and features a clean and intuitive user interface. The main goal of this project was to learn how to use React and Firebase together, and the result is a useful tool for any Yu-Gi-Oh! fan looking to keep track of their collection. Users can easily search for any card they want and save it to their list, and they can also view all Yu-Gi-Oh! cards on one of the app's pages. In the future, I hope to add more features to YugiDex, such as the ability to create custom decks and trade cards with other users.",
      tech: {
        React: L_REACT,
        React_Bootstrap: L_REACT_BOOTSTRAP,
        Firebase: L_FIREBASE,
      },
      features: [
        "Yu-Gi-Oh! card search: Users can search for specific Yu-Gi-Oh! cards by name or number to view detailed information about each card",
        "Yu-Gi-Oh! card list: Users can browse a list of all available Yu-Gi-Oh! cards and view basic information about each one",
        "Personal card list: Users can save their favorite Yu-Gi-Oh! cards to their own personal list for easy access",
        "Responsive design: The app is optimized for use on both desktop computers and mobile devices",
      ],
    },
    image: P_YUGI,
    link: "https://github.com/Parmvir-S/YugiDex",
  },
  {
    title: "Task Manager API",
    subtitle: "Node, Express, Mongo",
    description:
      "A backend project that builds an API for a task managing system using Node JS, Express and MongoDB.",
    data: {
      description:
        "The Task Manager API is a backend project built using express js, node js, and mongodb. It allows users to manage tasks, including creating, reading, updating, and deleting tasks. The API also allows for updating and deleting users. It can be used to read all tasks or a single task, and allows users to view a single user's profile. This project was a learning exercise for using node and express, and also included implementation of mongoose for connecting node with mongodb to simplify database queries.",
      tech: {
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        MongoDB: L_MONGODB,
      },
      features: [
        "User registration: Users can register for an account and create a new user profile",
        "User login: Users can login to their account using their email and password",
        "User logout: Users can logout of their account",
        "User logout of all instances: Users can logout of all instances of their account",
        "Task creation: Users can create new tasks and add them to their task list",
        "Task update: Users can update the details of their tasks as needed",
        "Task reading: Users can read their tasks and view the details of each one",
        "Task deletion: Users can delete tasks from their task list",
        "User update: Users can update their user profile information",
        "User deletion: Users can delete their user account",
        "Task reading (all tasks): Users can read all of the tasks in their task list",
        "Task reading (single task): Users can read a single task in their task list",
        "User profile viewing: Users can view their own user profile",
      ],
    },

    image: P_TASK,
    link: "https://github.com/Parmvir-S/Task-Manager-App",
  },
  {
    title: "Pokemon Game",
    subtitle: "HTML CSS Javascript",
    description:
      "A web game built using Vanilla Javascript, HTML and CSS that mimics rock paper scissors and allows players to battle other Pokemon. Through conditional logic, the winner of each round is determined based on the selected Pokemons type and its advantages.",
    data: {
      description:
        "The purpose of the Pokemon Battle Game is to provide users with a fun and simple way to play a game that mimics the classic rock-paper-scissors game. In this game, players can choose to play as one of three Pokemon types: fire, grass, or water. The game determines the winner and deals damage based on the relationship between the two Pokemon types: fire beats grass, grass beats water, and water beats fire.",
      tech: {
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Users can choose one of three Pokemon types: fire, grass or water",
        "The selected Pokemon fights a randomly selected Pokemon and damage is dealt based on type advantages (fire beats grass, grass beats water, and water beats fire)",
        "User and enemy health is both tracked. The first to 0 health loses",
      ],
    },
    image: P_POKEMON,
    link: "https://parmvir-s.github.io/pokemon-rps/",
  },
  {
    title: "Library Management",
    subtitle: "HTML CSS Javascript",
    description:
      "The Library Management System is a web application that allows users to keep track of books they have read and books they have yet to read. It was built using HTML, CSS, and JavaScript and includes features such as book addition, book list, book status update, book removal, book statistics, library clearing, and local storage",
    data: {
      description:
        "The library management system is a web application that allows users to keep track of the books they have read and the books they have yet to read. It was built using HTML, CSS, and vanilla JavaScript, and was motivated by the desire to practice DOM manipulation skills. The app features the ability to add a book with its author, title, number of pages, and a check of whether it has been read or not. Users can also view all of the books in their personal library in a table that is dynamically generated via DOM manipulation with JavaScript. If a user has a book in their library that they have not read and they have now read it, they can switch its status to 'read'. Users can also remove books from their library, view the total number of books they have in their library, and clear out their entire library with a single button click if desired. All of the book data is stored in the browser's local storage.",
      tech: {
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Book addition: Users can add a book to their library by providing the book's author, title, number of pages, and a check of whether they have read the book or not",
        "Book list: Users can view all of the books in their personal library in a table that is dynamically generated via DOM manipulation with JavaScript",
        "Book status update: If a user has a book in their library that they have not read, they can switch its status to 'read' once they have finished it",
        "Book removal: Users can remove books from their library as needed",
        "Book statistics: The app displays the total number of books in a user's library",
        "Library clearing: Users can clear out their entire library with a single button click if they wish to start over",
        "Local storage: All book data is stored in the browser's local storage, allowing users to access their library even if they close the app or switch devices",
      ],
    },
    image: P_LIBRARY,
    link: "https://parmvir-s.github.io/library-js/",
  },
  {
    title: "Calculator",
    subtitle: "HTML CSS Javascript",
    description: "A calculator app that includes the basic operators of addition, subtraction, multiplication, division, and modulo",
    data: {
      description:
        "The Calculator App is a web application built using html, css, and vanilla javascript. It has a clean design and includes the basic operators of addition, subtraction, multiplication, division, and modulo. It was created to practice dom manipulation skills, design skills, and piecing together smaller functions into a larger, functional app. It could be improved with better coding practices and responsive design.",
      tech: {
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Basic math operations: Users can perform basic mathematical operations such as addition, subtraction, multiplication, division, and modulo using the calculator",
        "Clean design: The calculator has a clean and aesthetically pleasing design, making it easy to use and visually appealing",
      ],
    },
    image: P_CALC,
    link: "https://parmvir-s.github.io/calculator/",
  },
  {
    title: "Food Tracker",
    subtitle: "Java",
    description:
      "A command line application that allows users to keep track of body metrics and daily food consumption, including calories, fat, carbs, and protein",
    data: {
      description:
        "The Food Tracker is a command line application built using Java. It allows users to keep track of their body metrics and daily food consumption, including calories, fat, carbs, and protein. It was created to help maintain a healthy lifestyle, and also served as a way to showcase knowledge gained through a Java MOOC course. The console application allows for multiple users and employs CRUD functionality for body metrics and food consumption data.",
      tech: {
        Java: L_JAVA,
      },
      features: [
        "Multiple user support: The Food Tracker allows for multiple users to track their body metrics and food intake",
        "CRUD functionality: The Food Tracker includes basic create, read, update, and delete functionality for body metrics and daily food consumption",
        "Tracking of body metrics: Users can track their height, weight, and other body metrics using the Food Tracker",
        "Tracking of daily food consumption: Users can track the calories, fat, carbs, and protein intake of their daily food consumption using the Food Tracker",
      ],
    },
    image: P_FOODTRACKER,
    link: "https://github.com/Parmvir-S/JavaFoodTracker",
  },
  {
    title: "Jump Game Extension",
    subtitle: "Javascript, HTML, CSS",
    description:
      "A chrome extension game that is a version of the dinosaur jump game, with the main character as Naruto and the object moving towards him as a kunai knife",
    data: {
      description:
        "The Naruto Jump Game is a chrome extension game built using css, html, and javascript. It is a version of the dinosaur jump game that appears when the internet is down, with the main character as Naruto and the object moving towards him as a kunai knife. The objective is to score as many points as possible by jumping over the object. It was created as a fun little game to play during downtime, and could be improved with the addition of a high score save feature.",
      tech: {
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Jumping gameplay: The main character, Naruto, must jump over approaching kunai knives in order to score points",
        "The score is tracked and displayed as the user progresses",
      ],
    },
    image: P_JUMPGAME,
    link: "https://github.com/Parmvir-S/jump-game-extension",
  },
  {
    title: "Fitness Blog",
    subtitle: "HTML CSS Bootstrap Javascript, React, Firebase",
    description: "A web application that allows users to share fitness posts, blogs, or log their daily workouts",
    data: {
      description:
        "The Fitness Blog is a web application built using react, react bootstrap, and firebase. It allows users to share fitness posts, blogs, or log their daily workouts. It makes use of the firebase sign in with google functionality, and also includes the ability to create and delete posts. It was created to allow friends to share workout logs and training programs, and also served as a chance to try out new authentication strategies for user login.",
      tech: {
        React: L_REACT,
        React_Bootstrap: L_REACT_BOOTSTRAP,
        Firebase: L_FIREBASE,
      },
      features: [
        "Google sign in: Users can sign in to the Fitness Blog using their Google account",
        "Post creation and deletion: Users can create posts and delete the posts that they have created themselves",
        "Post feed: Users can view posts that others have posted in their feed",
      ],
    },
    image: P_FITNESSBLOG,
    link: "https://github.com/Parmvir-S/Fitness-Blog",
  },
  {
    title: "Weather App",
    subtitle: "HTML CSS Javascript Node Express",
    description:
      "A web application that provides the weather forecast for any location, including information about weather description, temperature, feels like temperature, wind speed, pressure, humidity, and UV index",
    data: {
      description:
        "The Weather App is a web application built using node, express, and handlebars. It provides the weather forecast for any location, including information about weather description, temperature, feels like temperature, wind speed, pressure, humidity, and UV index. The weatherstack API is used for forecast data, and the mapbox API is used for location information. This project introduced me to using node and express, and also taught me how to deploy an app on heroku.",
      tech: {
        Node: L_NODE_JS,
        Express: L_EXPRESS,
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Weather forecasts: Users can enter a location to get the current weather forecast, including the weather description, temperature, feels like temperature, wind speed, pressure, humidity, and UV index",
        "Location search: Users can search for locations using the Mapbox API to get the weather forecast for that location",
      ],
    },
    image: P_WEATHERAPP,
    link: "https://github.com/Parmvir-S/Weather-App",
  },
  {
    title: "Google Homepage",
    subtitle: "HTML CSS Javascript",
    description:
      "Recreation of the google homepage using basic HTML, CSS, JavaScript and google chrome web developement tools",
    data: {
      description:
        "The Google Homepage Clone is a web application built using html, css and JavaScript. It is a recreation of the google homepage using basic html, css and JavaScript, and was one of the assignment projects on The Odin Project curriculum. It was created to learn how to use different html tags and use css to place elements where desired. While it is functional, it is not optimized for mobile displays and could be improved with better coding practices for html and css.",
      tech: {
        HTML: L_HTML5,
        CSS: L_CSS3,
        JavaScript: L_JAVASCRIPT,
      },
      features: [
        "Recreations of Google homepage elements: The Google Homepage Clone includes recreations of various elements found on the Google homepage, including the search bar, logo, and links to other Google services",
        "Functional search feature: Users can search for queries using the search bar on the Google Homepage Clone",
        "Additional elements: The Google Homepage Clone includes the Google logo and links to other Google services",
      ],
    },
    image: P_GOOGLE,
    link: "https://parmvir-s.github.io/google-homepage/",
  },
];

export const skills = {
  frontend: [
    {
      link: "https://reactjs.org/",
      imgAltText: "ReactJS",
      imgSrc: L_REACT,
      skillName: "ReactJS",
    },
    {
      link: "https://react-bootstrap.github.io/",
      imgAltText: "React Bootstrap",
      imgSrc: L_REACT_BOOTSTRAP,
      skillName: "React Bootstrap",
    },
    {
      link: "https://angular.io/",
      imgAltText: "Angular",
      imgSrc: L_ANGULAR,
      skillName: "Angular",
    },
    {
      link: "https://ngrx.io/",
      imgAltText: "NGRX",
      imgSrc: L_NGRX,
      skillName: "NGRX",
    },
    {
      link: "https://rxjs.dev/",
      imgAltText: "RxJS",
      imgSrc: L_RXJS,
      skillName: "RxJS",
    },
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
  ],
  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "NodeJS",
      imgSrc: L_NODE_JS,
      skillName: "NodeJS",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    },
    {
      link: "https://dotnet.microsoft.com/en-us/apps/aspnet",
      imgAltText: "ASP.NET",
      imgSrc: L_ASP,
      skillName: "ASP.NET",
    },
  ],
  hostingPlatforms: [
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },
    {
      link: "https://pages.github.com/",
      imgAltText: "GitHub Pages",
      imgSrc: L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
  ],
  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    {
      link: "https://www.python.org/",
      imgAltText: "Python",
      imgSrc: L_PYTHON,
      skillName: "Python",
    },
    {
      link: "https://www.java.com/en/",
      imgAltText: "Java",
      imgSrc: L_JAVA,
      skillName: "Java",
    },
    {
      link: "https://learn.microsoft.com/en-us/dotnet/csharp/",
      imgAltText: "C#",
      imgSrc: L_CSHARP,
      skillName: "C#",
    },
    {
      link: "https://www.cplusplus.com/",
      imgAltText: "C++",
      imgSrc: L_CPLUSPLUS,
      skillName: "C++",
    },
    {
      link: "https://racket-lang.org/",
      imgAltText: "Racket",
      imgSrc: L_RACKET,
      skillName: "Racket",
    },
  ],
  databases: [
    {
      link: "https://firebase.google.com/",
      imgAltText: "Firebase",
      imgSrc: L_FIREBASE,
      skillName: "Firebase",
    },
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
    {
      link: "https://www.oracle.com/ca-en/database/",
      imgAltText: "Oracle",
      imgSrc: L_ORACLE,
      skillName: "Oracle",
    },
    {
      link: "https://www.mysql.com/",
      imgAltText: "MySQL",
      imgSrc: L_MYSQL,
      skillName: "MySQL",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],
};
